import styled from 'styled-components';
import { Layout } from '@oneaudi/unified-web-components';
import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_SIZE_FIXED_100,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_RELATIVE_2_XL,
  SYS_SPACE_RELATIVE_3_XL,
  SYS_SPACE_RELATIVE_LG,
} from '@oneaudi/unified-web-common';

export const TilesContainer = styled.section<{ appContext?: string }>`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: ${SYS_SPACE_RELATIVE_2_XL};
  column-gap: ${SYS_SPACE_RELATIVE_LG};
  margin-bottom: ${SYS_SPACE_RELATIVE_2_XL};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    grid-template-columns: ${(props): string =>
      props.appContext && props.appContext === 'results' ? '1fr 1fr' : '1fr 1fr 1fr'};
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    grid-template-columns: ${(props): string =>
      props.appContext && props.appContext === 'results' ? '1fr 1fr 1fr' : '1fr 1fr 1fr 1fr'};
  }
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const SecondRow = styled.div<{ isGridView?: boolean }>`
  display: flex;
  flex-direction: ${(props): string => (props.isGridView ? 'column' : 'row')};
  gap: 5px;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: column;
  }

  > * {
    flex: 1 0 auto;
  }
`;

// margin-left ≙ 24px svg icon + margin of svg icon
export const LayoutContainer = styled(Layout)<{ appContext?: string }>`
  display: flex;
  flex-wrap: wrap;
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-left: ${SYS_SPACE_RELATIVE_3_XL};
    margin-left: ${(props): string =>
      props.appContext && props.appContext === 'results' ? SYS_SPACE_RELATIVE_3_XL : '0'};
  }
`;

export const ScoreAndFavoritesContainer = styled.div`
  padding-block-end: ${SYS_SIZE_FIXED_100};

  &:has(.matching-score-container) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: ${SYS_BREAKPOINT_SM}) {
      padding-inline-start: ${SYS_SPACE_FIXED_150};
    }
  }
`;
